import { Injectable } from '@angular/core';
import { HttpEvent, HttpInterceptor, HttpHandler, HttpRequest, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs/Rx';
import { Subject } from 'rxjs/Subject';
import * as _ from 'lodash';
/**
 * @abstract
 */
export abstract class HttpCache {
/**
 * @abstract
 * @param {?} req
 * @return {?}
 */
get(req: HttpRequest<any>) {}
/**
 * @abstract
 * @param {?} req
 * @param {?} resp
 * @return {?}
 */
put(req: HttpRequest<any>, resp: HttpResponse<any>) {}
}
export class HttpCacheService implements HttpCache {
public cache = {};
public reqUrls = [];

  onTemplateAdd: Subject<string> = new Subject<string>();
/**
 * @param {?} reqUrl
 * @return {?}
 */
checkIfUrlExists(reqUrl: string) {
    if (this.reqUrls.indexOf(reqUrl) < 0) {
      this.reqUrls.push(reqUrl);
      return false;
    }
    return true;
  }
/**
 * @param {?} req
 * @return {?}
 */
get(req: HttpRequest<any>): HttpResponse<any>|null {
    return _.cloneDeep(this.cache[req.urlWithParams]);
  }
/**
 * @param {?} req
 * @param {?} resp
 * @return {?}
 */
put(req: HttpRequest<any>, resp: HttpResponse<any>): void {
    this.cache[req.urlWithParams] = resp;
    this.onTemplateAdd.next(req.urlWithParams);
  }
static decorators: DecoratorInvocation[] = [
{ type: Injectable },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
}

function HttpCacheService_tsickle_Closure_declarations() {
/** @type {?} */
HttpCacheService.decorators;
/**
 * @nocollapse
 * @type {?}
 */
HttpCacheService.ctorParameters;
/** @type {?} */
HttpCacheService.prototype.cache;
/** @type {?} */
HttpCacheService.prototype.reqUrls;
/** @type {?} */
HttpCacheService.prototype.onTemplateAdd;
}


interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
